import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useGetOnePageOperatingLabels = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const onePageSectionLabels = {
      averageAnnualRevenue: t('onePageMapping.averageAnnualRevenue'),
      projectedAnnualIncome: t('onePageMapping.projectedAnnualIncome'),
      projectedPaybackPeriod: t('onePageMapping.projectedPaybackPeriod'),
      projectedProfitability: t('onePageMapping.projectedProfitability'),
      fundingNeeds: t('onePageMapping.fundingNeeds'),
      numberOfEmployees: t('onePageMapping.numberOfEmployees'),
      registrationDate: t('onePageMapping.registrationDate'),
      lifeCycleStage: t('onePageMapping.lifeCycleStage'),
      operatingIndustry: t('onePageMapping.operatingIndustry'),
    };
    return onePageSectionLabels;
  }, [t, i18n]);
};
